module.exports = __webpack_public_path__ + "img/bg.19916d04.svg";